import React, { useRef } from 'react'
import { useMapEvents } from 'react-leaflet'
import L from 'leaflet'

interface Props {
  mapRef: React.RefObject<L.Map>
  lineRef: React.RefObject<L.Polyline>
  positions: L.LatLng[]
  setLinePositions: (latLngs: L.LatLng[]) => void
}
const MapEvents = ({ mapRef, lineRef, positions, setLinePositions }: Props) => {
  /**In meter */
  // const SNAP_DISTANCE = 1000

  const isSnapped = useRef(false)

  useMapEvents({
    click: ({ latlng }) => {
      const latLngs = lineRef.current?.getLatLngs() as L.LatLng[]

      if ([0, 2].includes(positions.length)) setLinePositions([latlng])
      else {
        if (isSnapped) setLinePositions(latLngs)
        else setLinePositions([positions[0], latlng])
      }
    },
    mousemove: (e) => {
      let latlng = mapRef.current?.mouseEventToLatLng(e.originalEvent) as L.LatLng

      if (positions.length === 1) {
        const zoom = mapRef.current?.getZoom() as number

        mapRef.current?.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            const markerLatLng = layer.getLatLng()
            if (markerLatLng && markerLatLng.distanceTo(latlng) <= Math.exp(17 - zoom)) {
              latlng = markerLatLng
              isSnapped.current = true
            } else isSnapped.current = false
          }
        })

        lineRef.current?.setLatLngs([positions[0], latlng])
      }
    },
  })

  return null
}

export default MapEvents
